var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGefionFacility3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0V80H79.9342V0H0ZM75.2438 4.6905V28.143H4.6905V4.6905H75.2438ZM14.0715 32.8335H65.8627V65.9285H14.0715V32.8335ZM4.6905 75.3095V32.8335H9.38101V70.619H70.5532V32.8335H75.2437V75.3095H4.6905Z",
    fill: "#C49A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.37891 9.3811H14.0694V14.0716H9.37891V9.3811Z",
    fill: "#C49A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7598 9.3811H23.4503V14.0716H18.7598V9.3811Z",
    fill: "#C49A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1445 9.3811H32.835V14.0716H28.1445V9.3811Z",
    fill: "#C49A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7545 23.4526C48.634 23.4526 51.7903 20.2964 51.7903 16.4169C51.7903 12.5373 48.634 9.3811 44.7545 9.3811C40.875 9.3811 37.7188 12.5373 37.7188 16.4169C37.7188 20.2964 40.875 23.4526 44.7545 23.4526ZM44.7545 14.0716C46.0477 14.0716 47.0998 15.1237 47.0998 16.4169C47.0998 17.71 46.0477 18.7621 44.7545 18.7621C43.4613 18.7621 42.4093 17.71 42.4093 16.4169C42.4093 15.1237 43.4613 14.0716 44.7545 14.0716Z",
    fill: "#C49A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5162 23.4526C67.3957 23.4526 70.552 20.2964 70.552 16.4169C70.552 12.5373 67.3957 9.3811 63.5162 9.3811C59.6367 9.3811 56.4805 12.5373 56.4805 16.4169C56.4805 20.2964 59.6367 23.4526 63.5162 23.4526ZM63.5162 14.0716C64.8094 14.0716 65.8615 15.1237 65.8615 16.4169C65.8615 17.71 64.8094 18.7621 63.5162 18.7621C62.2231 18.7621 61.171 17.71 61.171 16.4169C61.171 15.1237 62.2231 14.0716 63.5162 14.0716Z",
    fill: "#C49A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7598 37.5239H61.1699V42.2144H18.7598V37.5239Z",
    fill: "#C49A36"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGefionFacility3);
export default __webpack_public_path__ + "static/media/gefion-facility-3.7d4cf0739406caaba294c8c1a858dcf2.svg";
export { ForwardRef as ReactComponent };